<template>
  <base-input :label="label">
    <datetime id="date-start" format="MM/DD/YYYY" v-model="date.date"></datetime>
  </base-input>
</template>

<script>
  import datetime from 'vuejs-datetimepicker';
  export default {
    name: 'my-data-picker',
    components: { datetime },
    props: ['date', 'label'],
    mounted() {
      $("#tj-datetime-input").css({"background":"border-box","color":"#9e9fa8","height": "38px", "border-radius":"0.4285rem", "border-color":"#2b3553", "outline-color":"#e14eca", "padding-left":"15px"});
      $(".datetime-picker").css({"width": "100%"});
      $(".nav-l").css({"background-color":"#e14eca"});
      $(".nav-r").css({"background-color":"#e14eca"});
      $(".year-month-wrapper").css({"background-color":"#e14eca"});
      $(".activePort").css({"background-color":"#e14eca"});
      $(".okButton").css({"color":"#e14eca"});
      $(".days").css({"color":"#e14eca"});

    }
  }

</script>

<style scoped>

</style>
